import { useIsDesktop } from "~/hooks/useIsDesktop";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "~/components/ui/drawer";
import { Mail } from "lucide-react";
import { Button } from "../ui/button";
import { useShopConfig } from "~/hooks/useShopConfig";
import { useTranslations } from "~/hooks/useTranslations";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

interface Props {
  open: boolean;
  onOk: () => void;
}

function Title() {
  const t = useTranslations();

  return (
    <div className="flex items-center gap-2">
      <Mail className="size-6 fill-black stroke-white" />
      <span>{t.incompatible_shipment_methods.title}</span>
    </div>
  );
}

function Content({ onOk }: Pick<Props, "onOk">) {
  const t = useTranslations();

  const {
    shopConfig: { commonConfiguration },
  } = useShopConfig();

  return (
    <div className="flex flex-col gap-4">
      <span className="text-sm text-muted-foreground">
        {t.incompatible_shipment_methods.description_1}
      </span>

      <span className="text-sm font-bold">
        {t.incompatible_shipment_methods.description_2}
      </span>

      <Button
        onClick={onOk}
        style={{
          backgroundColor: commonConfiguration?.sloganBackgroundColor,
          color: "#000",
        }}
      >
        {t.incompatible_shipment_methods.ok}
      </Button>
    </div>
  );
}

export function IncompatibleShipingMethods({ open, onOk }: Props) {
  const isDesktop = useIsDesktop();

  return isDesktop ? (
    <AlertDialog
      open={open}
      onOpenChange={(newOpen) => {
        if (!newOpen) {
          onOk();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <Title />
          </AlertDialogTitle>
          <AlertDialogDescription></AlertDialogDescription>
        </AlertDialogHeader>

        <Content onOk={onOk} />
      </AlertDialogContent>
    </AlertDialog>
  ) : (
    <Drawer
      open={open}
      onOpenChange={(newOpen) => {
        if (!newOpen) {
          onOk();
        }
      }}
    >
      <DrawerContent className="gap-4 px-4 pb-8">
        <DrawerHeader className="p-0">
          <DrawerTitle>
            <Title />
          </DrawerTitle>
          <DrawerDescription></DrawerDescription>
        </DrawerHeader>

        <Content onOk={onOk} />
      </DrawerContent>
    </Drawer>
  );
}
